import { Button, Panel } from "../../components";

type MicConsentProps = { onEnable: () => void; onSkip: () => void };

export function MicConsent({ onEnable, onSkip }: MicConsentProps) {
  return (
    <div class="stage stage-mic-consent">
      <p class="stage-kicker">Score this with your voice?</p>
      <Panel class="mic-consent">
        <p class="stage-lead-sm display">Turn on the mic</p>
        <p class="stage-detail">
          Your audio is analyzed on this device and never recorded, stored, or sent anywhere. It powers live
          scoring — phonation time, plosive timing, breath count — instead of self-judged honesty checks.
        </p>
        <div class="mic-consent-actions">
          <Button variant="ghost" onClick={onSkip}>
            Not now
          </Button>
          <Button onClick={onEnable}>Enable microphone</Button>
        </div>
      </Panel>
    </div>
  );
}
